// FIXME: JIV-15565 this rule has been disabled in order to preserve Ids during extraction
/* eslint-disable jira/i18n/id-named-by-package */
import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	delete: {
		id: 'issue.activity.worklog.delete-modal.delete',
		defaultMessage: 'Delete',
		description: 'Text for the delete confirmation button',
	},
	deleteHeading: {
		id: 'issue.activity.worklog.delete-modal.delete-heading',
		defaultMessage: 'Delete worklog entry?',
		description: 'Heading for the modal to delete a worklog entry',
	},
	cancel: {
		id: 'issue.activity.worklog.delete-modal.cancel',
		defaultMessage: 'Cancel',
		description: 'Text for the button to cancel deleting the worklog',
	},
	deleteWarning: {
		id: 'issue.activity.worklog.delete-modal.delete-warning',
		defaultMessage: "Once you delete, it's gone for good.",
		description: 'Warning for the delete modal to delete a worklog entry',
	},
	adjustCheckboxLabel: {
		id: 'issue.activity.worklog.delete-modal.adjust-checkbox-label',
		defaultMessage: 'Adjust time remaining',
		description: 'Label for the checkbox to adjust the remaining time in the worklog delete modal',
	},
	adjustCurrentLabel: {
		id: 'issue.activity.worklog.delete-modal.adjust-current-label',
		defaultMessage: 'Current',
		description: 'Label for the current time remaining',
	},
	adjustNewLabel: {
		id: 'issue.activity.worklog.delete-modal.adjust-new-label',
		defaultMessage: 'New time remaining',
		description: 'Label for the new time remaining',
	},
	adjustNewSubtext: {
		id: 'issue.activity.worklog.delete-modal.adjust-new-subtext',
		defaultMessage: 'By default, deleted time ({timeSpent}) is added to the time remaining.',
		description: 'Subtext for the new time remaining input',
	},
});
